import { Switch } from "antd";
import React from "react";
import style from "./Toogle.module.css";

function CustomToogle({ handleChange, checked, namespace, disabled }) {
  return <Switch className={style.BaseToogle} id={namespace} onChange={(e) => handleChange(e)} checked={checked} disabled={disabled} />;
}

export default CustomToogle;
